export function observeIntersection(targetContainer, targetLoaded, fetchFn) {
  const observer = new IntersectionObserver( (changes)=> {
    for (const change of changes) {
      if (targetLoaded === true){
        return
      }
      if (change.isIntersecting === false) {
        return
      }
      targetLoaded = true

      fetchFn();
    }
  });

  observer.observe(targetContainer)
}